import { AppStateCreator, AuditVehicleMaintenanceFiltersState } from "../types";
import { AuditsSlice } from "../types";
import { useAppStore } from ".";
import { initialState } from ".";

export const createAuditSlice: AppStateCreator<AuditsSlice> = (set) => ({
  auditsMaintenance: {
    page: initialState.audits.vehicleMaintenance.filters.page,
    filters: {
      search: initialState.audits.vehicleMaintenance.filters.search,
      status: initialState.audits.vehicleMaintenance.filters.status,
    },
    
    setPage: (page: number) => {
      set((state) => ({
        auditsMaintenance: {
          ...state.auditsMaintenance,
          page: page,
        },
      }));
    },
    
    setFilters: (newFilters: Partial<AuditVehicleMaintenanceFiltersState["filters"]>) =>
      set((state) => ({
        auditsMaintenance: {
          ...state.auditsMaintenance,
          filters: {
            ...state.auditsMaintenance.filters,
            ...newFilters,
          },
        },
      })),
  },
});

export const useAuditMaintenanceState = () => 
  useAppStore((state) => state.auditsMaintenance);
